import { useEffect, useState } from "react";
import { Flame, Clock3 } from "lucide-react";
import { api } from "../../lib/api";

const rateColor = (r) => (r >= 80 ? "text-emerald-700" : r >= 50 ? "text-amber-600" : "text-rose-600");

export function useStandupStats(deps = []) {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/standups/stats").then(r => setStats(r.data)).catch(() => setStats([])); }, deps);
  return stats;
}

export function StreakBadge({ s }) {
  if (!s) return null;
  return (
    <span className="inline-flex items-center gap-2 text-xs" data-testid="my-streak-badge">
      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border ${s.streak ? "bg-orange-50 border-orange-300 text-orange-700" : "bg-neutral-50 border-neutral-200 text-neutral-500"}`}>
        <Flame className="w-3.5 h-3.5" />{s.streak} day streak
      </span>
      <span className={`inline-flex items-center gap-1 ${rateColor(s.on_time_rate)}`}><Clock3 className="w-3.5 h-3.5" />{s.on_time_rate}% on time</span>
    </span>
  );
}

export function TeamStreaks({ stats }) {
  if (!stats) return null;
  return (
    <div className="panel p-4 space-y-3" data-testid="team-streaks">
      <div>
        <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-orange-400">Consistency</div>
        <h3 className="font-bold">Streaks & on-time rate</h3>
        <p className="text-xs text-neutral-500">Streak = weekdays in a row with a standup. On time = posted before 11 AM IST, over the last 5 weekdays.</p>
      </div>
      {stats.length === 0 ? <div className="text-xs text-neutral-500">No developers or testers on your active projects yet.</div> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-[10px] font-mono uppercase tracking-wider text-neutral-500 text-left">
              <th className="py-2 pr-3">Person</th><th className="py-2 pr-3">Streak</th><th className="py-2 pr-3">On time</th><th className="py-2 pr-3">Posted</th><th className="py-2">Today</th>
            </tr></thead>
            <tbody>
              {stats.map(s => (
                <tr key={s.user_id} className="border-t border-neutral-100" data-testid={`streak-row-${s.user_id}`}>
                  <td className="py-2 pr-3"><div className="font-medium">{s.name}</div><div className="text-[10px] font-mono uppercase text-neutral-500">{s.role}</div></td>
                  <td className="py-2 pr-3"><span className={`inline-flex items-center gap-1 font-semibold ${s.streak ? "text-orange-600" : "text-neutral-400"}`}><Flame className="w-4 h-4" />{s.streak}</span></td>
                  <td className={`py-2 pr-3 font-semibold ${rateColor(s.on_time_rate)}`}>{s.on_time_rate}%</td>
                  <td className="py-2 pr-3 text-neutral-600 font-mono text-xs">{s.posted_days}/{s.counted_days} days</td>
                  <td className="py-2">{s.posted_today ? <span className="text-emerald-700 text-xs">Posted</span> : <span className="text-neutral-400 text-xs">Not yet</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
